import type { BlisRole } from "@blis/config";

import {
  evaluateAllowedOrgs,
  evaluateAttributes,
  evaluateOrg,
  evaluateRole,
} from "./json-eval";
import { authMapperSchema } from "./schema";

export type BlisAuth = {
  role?: BlisRole;
  org?: number;
  allowedOrgs?: number[];

  [x: string]: unknown;
};

export type MapperEvaluation = {
  blisAuth: BlisAuth;

  [x: string]: unknown;
};

export function evaluateAuthMappers(
  attributes: Record<string, unknown>,
  payload: unknown,
): MapperEvaluation {
  const parsed = authMapperSchema.parse(payload);

  const newAttrs = evaluateAttributes(attributes, parsed.attributes);
  const role = evaluateRole(attributes, parsed.roles);
  const org = evaluateOrg(attributes, parsed.orgs);
  const allowedOrgs = evaluateAllowedOrgs(attributes, parsed.allowedOrgs);

  const blisAuth: BlisAuth = { ...newAttrs, role, org, allowedOrgs };

  // for backwards compatibility
  if (role && attributes.roles && Array.isArray(attributes.roles)) {
    attributes.roles.push(role);
  }

  return {
    blisAuth,
    ...attributes,
    ...newAttrs,
  };
}
